import React from 'react';

export default function SoftSkillsIcon() {
  return (
    <svg
      className="svg-icon"
      width="46px"
      height="45px"
      viewBox="0 0 46 45"
      role="img"
      aria-labelledby="soft-skills-icon-title"
    >
      <title id="soft-skills-icon-title">Soft Skills Icon</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#19A6A8" fillRule="nonzero">
          <path
            d={
              'M7.49997009,15 L1.50002991,15 C0.675174986,15 ' +
              '0,15.6717737 0,16.4999596 L0,43.5002199 C0,44.3280468 ' +
              '0.672213692,45 1.50002991,45 L7.49997009,45 C8.32778631,45 ' +
              '9,44.3279571 9,43.5002199 L9,16.4999596 C9,15.6717737 8.32473528,15 ' +
              '7.49997009,15 Z'
            }
          />
          <path
            d={
              'M42.2488871,14.0478216 C42.0069247,14.0069741 ' +
              '30.6775687,14.0478216 30.6775687,14.0478216 L32.2600312,9.74521924 ' +
              'C33.3519177,6.77356429 32.6449958,2.23617844 29.6153433,0.623060868 ' +
              'C28.6288884,0.0977764699 27.2506379,-0.166030241 ' +
              '26.1394267,0.112735968 C25.5021634,0.272542817 ' +
              '24.9421087,0.693021153 24.6082869,1.25637613 ' +
              'C24.2244009,1.90429258 24.2640389,2.6605982 24.1273284,3.3790124 ' +
              'C23.7806535,5.20120463 22.9167078,6.93372945 21.5788142,8.23413081 ' +
              'C19.2461967,10.5014353 12,17.0424085 12,17.0424085 L12,41 ' +
              'L37.040495,41 C40.419339,41.0019699 42.6336719,37.2414926 ' +
              '40.9671698,34.304146 C42.9536518,33.0361718 43.6330698,30.3654088 ' +
              '42.4696373,28.3147931 C44.4562091,27.0468189 45.1355373,24.3760559 ' +
              '43.9721047,22.3254402 C47.3996648,20.1376808 46.2537592,14.7228801 ' +
              '42.2488871,14.0478216 Z'
            }
          />
        </g>
      </g>
    </svg>
  );
}
